<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Attendance Devices</span>
        </h4>

        <div class="row no-margin mt-4">
            <div class="ibox col-md-12 px-4">
                <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                <div class="ibox-title dashboard_title px-0">
                    <h4>Attendance Devices</h4>
                </div>
                <div class="ibox-content px-0 pt-4 employee-table-wrapper">
                    <div class="row no-gutters py-2 mb-3 pl-0 ">
                        <div class="col-sm-6">
                            <div class="custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title">
                            <b-button id="show-btn" v-if="disabled_by_acl == false" @click="addNew(false)">Add Device</b-button>
                        </div>
                    </div>

                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <table class="table dataTable no-sort-icon leave-table">
                            <thead>
                                <tr class="table-head">
                                    <th>IP Address</th>
                                    <th>Port</th>
                                    <th class="text-right" v-if="disabled_by_acl == false">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(device, n) in paginatedData" :key="device.id">
                                    <td>{{device.ip_address}}</td>
                                    <td>{{device.port}}</td>
                                    <td v-if="disabled_by_acl == false">
                                        <div class="float-right position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group>
                                                        <b-button variant="outline-secondary" @click="editDevice(device.id)">
                                                            <b-icon icon="pencil"></b-icon> Edit
                                                        </b-button>
                                                        <b-button variant="outline-secondary" @click="deleteDevice(device.id)">
                                                            <b-icon icon="trash"></b-icon> Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                                </ul>
                                <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>
                            </div>
                        </div>

                        <div v-if="this.flg == 1" class="mt-3">
                            <b-button type="button" @click="set_go_next(1)" variant="primary" class="float-right mt-3 mr-3">Go Next</b-button>
                            <b-button type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go Back</b-button>
                            <b-button type="button" @click="setfinish(1)" variant="success" class="float-right mt-3 mx-3">Finish</b-button>
                        </div>

                    </b-overlay>
                </div>
            </div>
        </div>


        <!-- Abdullah after live added this dynamic title  -->
        <b-modal id="bv-modal-device" size="lg" hide-footer :title="attendance_device_title">
            <b-overlay :show="showoverlay" rounded="sm">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-group id="ip_address-group" label="IP Address" class="required-field" label-for="ip_address">
                                <b-form-input id="ip_address" name="ip_address" v-model="fdata.ip_address" v-validate="{ required: true, min: 3, regex: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/ }" :state="validateState('ip_address')" aria-describedby="ip_address-feedback" data-vv-as="IP Address"></b-form-input>
                                <b-form-invalid-feedback id="ip_address-feedback">{{ veeErrors.first('ip_address') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        <div class="col-sm-12">
                            <b-form-group id="port-group" label="Port" class="required-field" label-for="port">
                                <b-form-input id="port" name="port" v-model="fdata.port" v-validate="{ required: true, numeric: true }" :state="validateState('port')" aria-describedby="port-feedback" data-vv-as="Port"></b-form-input>
                                <b-form-invalid-feedback id="port-feedback">{{ veeErrors.first('port') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        <div class="col-sm-12">
                            <b-form-group id="password-group" label="Password" label-for="password">
                                <b-form-input type="password" id="password" name="password" v-model="fdata.password" v-validate="{ }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                                <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="btn-wrapper text-center pt-5">
                        <b-button class="ml-2 btn-primary custom-wizard-btn" variant="primary" @click="resetForm()">Reset</b-button>
                        <b-button class="btn-primary" type="submit" variant="primary">Submit</b-button>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>

    </div>
</template>


<script>
    export default {

        mounted() {

        },
        props: ['ce_flg', 'check_ce', 'flg'],
        data() {

            return {

                devices: [],
                errormsg: [],
                fdata: { status: null, id: null },
                saved_name: '',

                draftdata: {},
                file: null,
                showoverlay: false,
                showoverlay_list: false,
                go_back: false,
                go_next: false,
                finish: false,

                search: '',
                blankmsg: 'Fetching data..',
                length: 20,
                temp_length: 20,
                length_options: [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],

                people: 0,
                pagination: { currentPage: 1, pages: 1 },

                successmsg: false,
                warningmsg: false,
                dangermsg: false,

                addtype: false,
                disabled_by_acl: false,
                acl: this.$acl,

                // Abdullah after live added this
                attendance_device_title: 'Add Attendance Device',

            }
        },
        methods: {

            showMessage: function () {
                let tmp_flg = 0;
                if (this.devices.length > 0) tmp_flg = 1;
                let childdata = { flg: tmp_flg, successmsg: this.successmsg, warningmsg: this.warningmsg, dangermsg: this.dangermsg, move_next: this.go_next, move_back: this.go_back, finish: this.finish };
                this.$emit('childToParent', childdata);
            },
            set_go_back(x) {
                this.go_next = false;
                this.go_back = true;
                this.finish = false;
                if (x == 1) this.showMessage();
            },
            set_go_next(x) {
                this.go_next = true;
                this.go_back = false;
                this.finish = false;
                if (x == 1) this.showMessage();
            },
            disable_set_go_next() {
                this.go_next = false;
            },
            setfinish(x) {
                this.finish = true;
                this.go_next = false;
                this.go_back = false;
                if (x == 1) this.showMessage();
            },

            addNew(x) {
                this.addtype = x;
                this.resetForm();
                // Abdullah after live added this
                this.attendance_device_title = 'Add Attendance Device';
                this.$bvModal.show('bv-modal-device');
            },

            getDeviceData: function () {
                if (!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url + '/attendance-device/list', {
                    params: {}
                }).then(function (response) {
                    this.devices = response.data;
                    this.people = this.devices.length;

                    if (this.devices.length == 0)
                        this.blankmsg = 'Nothing found.';

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            },

            editDevice: function (id) {
                this.addtype = false;
                if (!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;

                let asd = this.devices;
                var item = asd.find(item => item.id === id);
                this.fdata = item;

                this.$validator.reset();
                this.showoverlay = false;
                // abdullah after live added this
                this.attendance_device_title = 'Edit Attendance Device';
                this.$bvModal.show('bv-modal-device');
            },

            deleteDevice: function (x) {
                if (!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this device.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
                })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        let currentObj = this;
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/attendance-device/delete', formData).then(function (response) {
                            this.devices = [];
                            this.devices = response.data;
                            this.people = this.devices.length;
                            this.resetPagination();
                            this.showoverlay_list = false;

                            this.$bvToast.toast('Deleted!', {
                                title: 'Success',
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this))
                        .catch(function (error) {
                            currentObj.serverError(error);
                        });
                    }
                })
                .catch(err => {});
            },

            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            resetForm() {
                this.fdata = { ip_address: null, port: null, password: null, status: null, id: null };
                this.file = null;
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },

            onSubmit(e) {
                if (!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    };

                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata)) {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    axios.post(this.$api_url + '/attendance-device/save', formData, config)
                        .then(function (response) {
                            this.devices = response.data;
                            this.people = this.devices.length;
                            this.resetPagination();

                            this.successmsg = 'Saved!';
                            this.$bvToast.toast('Saved!', {
                                title: 'Success',
                                variant: 'success',
                                solid: true
                            });

                            this.resetForm();
                            this.$bvModal.hide('bv-modal-device');

                        }.bind(this))
                        .catch(function (error) {
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },

        },
        created: function () {
            this.getDeviceData();
            Fire.$on('reloadUsers', () => { this.getDeviceData() });
            if (this.acl['leave-attendances'] != 2) {
                this.disabled_by_acl = true;
            }
        },
        computed: {
            filteredData() {
                let filtered_list = this.devices;
                if (this.search) {
                    filtered_list = filtered_list.filter((row) => {
                        return Object.keys(row).some((key) => {
                            return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                        });
                    });

                    if (filtered_list.length == 0)
                        this.blankmsg = 'Nothing found.';
                }
                return filtered_list;
            },
            paginatedData() {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
<label for=""></label>
